import { NextLink, Translate } from '~/i18n';
import classNames from 'classnames';
import { useRouter } from 'next/router';
/******************************************************************
 *
 *  THIS COMPONENT WAS GENERATED BY NEXTCRAZY-CLI
 *
 ******************************************************************/
interface AbourheaderProps {
   classname?: string;
}
const links = [
   {
      href: '/about',
      title: <Translate id="common:about halayalla" />,
   },
   {
      href: '/business',
      title: <Translate id="common:hala yalla for business" />,
   },
   {
      href: 'https://halayalla.com/halayalla-business/invest-in-apps.php',
      title: <Translate id="footer:investor relations" />,
      external: true,
   },
];

const AboutHeader = ({ classname }: AbourheaderProps) => {
   const router = useRouter();
   return (
      <div className="flex flex-wrap items-center flex-grow xs:gap-x-8 gap-x-3">
         {links.map(({ href, title, external }, idx) => {
            const isActive = router.pathname === `/[lang]${href}`;
            return external ? (
               <a
                  className={classNames(
                     classname ? classname : 'text-xs font-medium hover:opacity-100',
                     !isActive && 'opacity-75'
                  )}
                  key={idx}
                  href={href}
                  rel="noreferrer noopener"
                  target="_blank">
                  {title}
               </a>
            ) : (
               <NextLink
                  className={classNames(
                     classname ? classname : 'text-xs font-medium hover:opacity-100',
                     !isActive && 'opacity-75'
                  )}
                  key={idx}
                  href={href}>
                  {title}
               </NextLink>
            );
         })}
      </div>
   );
};

export default AboutHeader;
